import { createWebHashHistory, createRouter } from 'vue-router';
import adminRoutes from './AdminRoutes';
import authRoutes from './authRoutes';
import Cookies from "js-cookie";

const routes = [
  {
    name: 'Admin',
    path: '/',
    component: () => import(/* webpackChunkName: "admin" */ '@/layout/withAdminLayout.vue'),
    children: [...adminRoutes],
    meta: { auth: false },
  },
  {
    name: 'Auth',
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/layout/withAuthLayout.vue'),
    children: [...authRoutes],
    meta: { auth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(
  ),
  linkExactActiveClass: 'active',
  routes,
});

router.beforeEach((to, from, next) => {
  const logged_token = Cookies.get("LoggedUser")
  
  // console.log(to, store);
  if (to.meta.auth && logged_token) {
    next({ to: '/' });
  } else if (!to.meta.auth && !logged_token) {
    next({ name: 'login' });
  } else {
    next();
  }
  window.scrollTo(0, 0); // reset scroll position to top of page
  next();
});

export default router;
